// extracted by mini-css-extract-plugin
export default {"wrap":"sG-z","fullWidth":"tG-z","hideOnDesktop":"uG-z","content":"vG-z","hasOpenedNav":"wG-z","crumbsList":"xG-z","dropdownsWrap":"yG-z"};